import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CircleIcon from '@mui/icons-material/CheckCircle';

const NotificationRow = ({ notification, onReview, isPending }) => {
    return (
        <Box component={Paper} elevation={3} className='notifications-box' >
            <Box className='status-container'>
                <FiberManualRecordIcon fontSize="0.9rem" color={isPending ? "error" : "success"} />
                <Typography variant="body2" color={isPending ? "error" : "#2e7d32"} fontWeight="bold">
                    {notification.status}
                </Typography>
            </Box>
            <Box className='container'>
                <Typography variant="body2" fontWeight="bold">{notification.title}</Typography>
            </Box>
            <Box className='container'>
                <Typography variant="body2">{notification.received}</Typography>
            </Box>
            <Box className='container'>
                <Typography variant="body2">{notification.dueDate}</Typography>
            </Box>
            <Box className='container'>
                <Typography variant="body2">{notification.supplierNumber}</Typography>
            </Box>
            <Box className='container'>
                {isPending ? (
                    <Button variant="secondary" size="small" onClick={() => onReview(notification, notification.supplierNumber)}>
                        {notification.action}
                    </Button>
                ) : (
                    <CircleIcon color="success" />
                )}
            </Box>
        </Box>
    );
};

export default NotificationRow;
